// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import * as tslib_1 from "tslib";
// THIS FILE WAS AUTOGENERATED
import { PageViewData } from './PageViewData';
/**
 * An instance of PageViewPerf represents: a page view with no performance data, a page view with performance data, or just the performance data of an earlier page request.
 */
var PageViewPerfData = /** @class */ (function (_super) {
    tslib_1.__extends(PageViewPerfData, _super);
    function PageViewPerfData() {
        var _this = _super.call(this) || this;
        _this.ver = 2;
        _this.properties = {};
        _this.measurements = {};
        return _this;
    }
    return PageViewPerfData;
}(PageViewData));
export { PageViewPerfData };
//# sourceMappingURL=PageViewPerfData.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-common/dist-esm/Interfaces/Contracts/Generated/PageViewPerfData.js
// module id = 580
// module chunks = 42